// src/views/sso/SsoPageWrapper.js (새 파일)
import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './SsoPage.module.css';
import { Fido2 } from '../../core/fido2.ts';
import { uploadProfileImage } from '../../utils/api/storageApiClient';

function SsoPageWrapper({ htmlFile, title, sandboxOptions = "allow-scripts allow-forms allow-same-origin allow-popups allow-modals" }) {
    const location = useLocation();
    const iframeRef = useRef(null);

    useEffect(() => {
        window.Fido2 = Fido2;
        window.uploadProfileImage = uploadProfileImage;

        const handleMessage = (event) => {
            const data = event.data;

            // 메시지를 보낸 주체가 iframe인지, 아니면 opener(SDK)인지 확인
            const isFromIframe = event.source === iframeRef.current?.contentWindow;
            const isFromOpener = event.source === window.opener;

            if (isFromIframe) {
                // Iframe에서 온 메시지는 Opener(SDK)로 전달
                if (window.opener) {
                    window.opener.postMessage(data, "*"); // event.origin 대신 '*' 또는 opener의 origin 사용
                    if (data.type === "token_result") {
                        window.close();
                    }
                }
            } else if (isFromOpener) {
                // Opener(SDK)에서 온 메시지는 Iframe으로 전달
                if (iframeRef.current?.contentWindow) {
                    iframeRef.current.contentWindow.postMessage(data, '*');
                }
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
            delete window.Fido2;
            delete window.uploadProfileImage;
        };
    }, []);

    const iframeSrc = `/sso/${htmlFile}${location.search}`;

    return (
        <div className={styles.container}>
            <iframe
                ref={iframeRef}
                src={iframeSrc}
                className={styles.iframe}
                title={title}
                sandbox={sandboxOptions}
            />
        </div>
    );
}
export default SsoPageWrapper;